export default __webpack_public_path__ + "static/media/women_s day.f665d438.jpg";